module.exports = __webpack_public_path__ + "static/media/galerija_2017 (28).7e7589fc.jpg";